module.exports = __webpack_public_path__ + "assets/6711b9a724347789d390ba35308157da.png";